import './styles.scss'
import React, { useEffect } from 'react'
import * as OperatorActions from '../../../../redux/actions/operators'
import { rolesAct } from '../../../../redux/actions'
import { Container } from 'reactstrap'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import OperatorsTable from './OperatorsTable'
import { lang } from 'utils/helpers'

const Index = ({ operators, companies, getOperators, getRoles, history, match, user, brands, delegations }) => {
  useEffect(() => {
    getOperators({ idCompany: companies._id })
    getRoles()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const operatorsList = Object.values(operators).reduce(
    (current, next) => {
      // Usuarios Activos
      if (next.isActive) {
        current.activated.push(next)

        // Usuarios Pendiente de registro
      } else if (!next.isComplete && !next.isActive) {
        current.withoutRegistration.push(next)

        // Usuarios Desactivados
      } else if (!next.isActive) {
        current.desactivated.push(next)
      }

      return current
    },
    { activated: [], desactivated: [], withoutRegistration: [] }
  )

  return (
    <div className='animated fadeIn'>
      <Container fluid className='py-5 users-management'>
        {/* Operadores Activos */}
        <OperatorsTable
          user={user._id}
          operators={operatorsList.activated}
          header={companies.type === 'OP'
            ? lang('dashboard_managers')
            : lang('dashboard_operators')
          }
          addUser={['root', 'owner', 'admin'].includes(user.role)}
          {...{ companies, brands, delegations, history, match }}
        />

        {/* Operadores Sin Registro */}
        <OperatorsTable
          operators={operatorsList.withoutRegistration}
          header={companies.type === 'OP'
            ? lang('dashboard_managers-pending-registration')
            : lang('dashboard_operators-pending-registration')
          }
          {...{ companies, brands, delegations, history, match }}
        />

        {/* Operadores Desactivados */}
        <OperatorsTable
          user={user._id}
          operators={operatorsList.desactivated}
          header={companies.type === 'OP' ? lang('dashboard_disabled-managers') : lang('dashboard_disabled-operators')}
          {...{ companies, brands, delegations, history, match }}
        />
      </Container>
    </div>
  )
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(Object.assign({}, OperatorActions, rolesAct), dispatch)
}

function mapStateToProps(state) {
  return {
    user: state.user,
    companies: state.companies,
    brands: state.brands,
    delegations: state.delegations,
    operators: state.operators
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Index))
